import * as React from 'react';
import Button from '@material-ui/core/Button';
import LockResetIcon from '@mui/icons-material/LockReset';

function ResetPasswordLink({password_resets_edit_path} :any) {
  return (
    <p className="clearfix">
      <span className="float-left">Password</span>
      <span className="float-right text-muted">
        <Button
          href={password_resets_edit_path}
          size="small"
          variant="outlined"
          startIcon={<LockResetIcon />}
        >
          Reset your password
        </Button>
      </span>
    </p>
  );
}

export default ResetPasswordLink;
